export default {
    title: "HR",
    icon: "mdi-account-group",
    capability: "hr.area",
    groups: ["Amministrazione"],
    divider: true,
    submenu: [
        { title: "Dashboard", route: { name: "hr-dashboard" }, exact: true, capability: "hr.area", groups: ["Amministrazione"] },
        { title: "Dipendenti", route: { name: "hr-dipendenti" }, capability: "hr.area", groups: ["Amministrazione"] },
        { title: "Comunicazioni", route: { name: "hr-comunicazioni" }, capability: "hr.area", groups: ["Amministrazione"] },
        { title: "Recruiting", route: { name: "hr-recruiting" }, capability: "hr.area", groups: ["Amministrazione"] },
        { title: "Amministrazione", route: { name: "hr-amministrazione" }, capability: "hr.area", groups: ["Amministrazione"] },
        { title: "Competenze", route: { name: "hr-competenze" }, capability: "hr.area", groups: ["Amministrazione"] },
        { title: "Mansioni", route: { name: "hr-mansioni" }, capability: "hr.area", groups: ["Amministrazione"] },
        { title: "Colloqui", route: { name: "hr-colloqui" }, capability: "hr.area", groups: ["Amministrazione"] },
        { title: "Skill matrix", route: { name: "hr-centri-lavoro" }, capability: "hr.area", groups: ["Amministrazione"] },
    ],
};
